import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1012a180"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import router from "@/router";
import { Authorization, LogStatus } from "@/services/authenticate";
import { onMounted, reactive } from "vue";
import LoadingDots from "@/components/util/LoadingDots.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const state = reactive({
    status: 0
});

onMounted(async () => {
    loggedCheck(Authorization.logStatus);
    state.status = 0;
    await Authorization.signIn();
    if (Authorization.logStatus == LogStatus.Logged) {
        state.status = 1;
        loggedCheck(Authorization.logStatus);
        await loadInitialData();
    }
    else {
        state.status = -1;
    }
});

function loggedCheck(value: LogStatus) {
    if (value == LogStatus.Logged) {
        const destination = sessionStorage.getItem("log_to") ?? '/';
        sessionStorage.removeItem("log_to");
        const [path, queryString] = destination.split("?");
        const query = {} as any;
        if (queryString) {
            const params = new URLSearchParams(queryString);
            for (const [key, value] of params) {
                query[key] = value;
            }
        }
        router.push({ path, query });
    }
}

async function loadInitialData() {

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_Transition, { name: "slide-fade" }, {
          default: _withCtx(() => [
            (state.status == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Trying to log you in..."))
              : (state.status == 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Succesfully logged, you will be redirected"))
                : (state.status == -1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "You need to log in with ABB account"))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(LoadingDots, { class: "loading" })
      ])
    ])
  ]))
}
}

})